import { useStore } from "../store/useStore";

export const useAuth = () => {
  const user = useStore((state) => state.user);
  const isAuthenticated = useStore((state) => state.isAuthenticated);
  const loading = useStore((state) => state.loading.auth);

  return {
    user,
    isAuthenticated,
    initialized: !loading,
  };
};
